import { memo, MouseEvent, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";

import CONSTANTS from "constants/constant";

import pathnames from "routes/pathnames";

import AppAlert from "components/app-alert";
import HeaderInbox from "components/app-header/header-inbox";

import { resetProfile } from "store/slices/profile-slice";

import arrowUp from "assets/images/components/app-faq-table/arrow-up.svg";
import arrowDown from "assets/images/components/app-faq-table/arrow-down.svg";

const AppHeader = () => {
	const navigate = useNavigate();

	const dispatch = useDispatch();

	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const hideNotification = true;

	const onHandleOpenMenu = (event: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const onHandleCloseMenu = () => {
		setAnchorEl(null);
	};

	const onHandleLogout = useCallback(() => {
		localStorage.clear();

		sessionStorage.clear();

		dispatch(resetProfile());

		dispatch({ type: CONSTANTS.REDUX_ACTION.LOGOUT });

		navigate(pathnames.default);
	}, [navigate, dispatch]);

	return (
		<header className="app-header">
			<div className="header">
				{!hideNotification && <HeaderInbox />}

				{!hideNotification && <div className="header__separator"></div>}

				<div className="header-action">
					<button className="header-action__cta" onClick={onHandleOpenMenu}>
						<span className="header-action__cta--text">Admin</span>

						<img src={anchorEl ? arrowUp : arrowDown} alt="arrow" />
					</button>

					<Menu className="header-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onHandleCloseMenu}>
						<MenuItem onClick={onHandleLogout}>Log Out</MenuItem>
					</Menu>
				</div>
			</div>

			<AppAlert />
		</header>
	);
};

export default memo(AppHeader);
